// console.clear();

import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

document.addEventListener('DOMContentLoaded', function () {

  /*--------------------------------------
  hash
  */
  const html = document.querySelector('html');
  const hash = window.location.hash;

  /*--------------------------------------
  カウントアップ
  */

  //年を一文字ずつspanでwrapする

  function toSpan(num) {
    let spans = num.toString().split('').map(digit => `<span>${digit}</span>`);
    return spans.join('');
  }

  //init
  const yearElm = document.getElementById("year");
  const thisYear = new Date().getFullYear();
  const startYear = 1974;
  const diff = thisYear - startYear + 10; // for time spece at first & last
  yearElm.innerHTML = toSpan(startYear);
  let currentYear = startYear;


  /*--------------------------------------
  GSAP
  */
  let tl;
  let mainTL;
  let gsapInit = false;

  function runGsap() {

    gsap.registerPlugin(ScrollTrigger);
    gsap.defaults({ ease: "none" }); //再考？
    gsap.config({ force3D: true });

    /*--------------------------------------
    グローバルタイムライン
    全アニメーションのprogress
    */


    tl = gsap.timeline({
      onUpdate: function () {
        let tlProgress = tl.progress();
        if (tlProgress < 0.1) {
          currentYear = startYear;
        } else if (tlProgress > 0.9) {
          currentYear = thisYear;
        } else {
          currentYear = Math.floor(startYear + (diff * (tlProgress - 0.1)));
        }
        yearElm.innerHTML = toSpan(currentYear);
      }
    });
    tl.pause();

    /*--------------------------------------
    メインタイムライン
    発火タイミング
    */
    const wrapper = document.querySelector(".countup__container");


    let wh = window.innerHeight;
    let direction = 1;

    function mainTLonEnter() {
      if (!tl.isActive()) {
        tl.play();
      }
    }

    function mainTLonEnterBack() {
      tl.reverse();
    }

    function mainTLonUpdate(tween) {
      //tween = mainTL
      if (tween.direction !== tween.prevDirection) {
        if (tween.direction === 1) {
          direction = 1;

          tl.play();
          if (!html.classList.contains('active')) {
            html.classList.add('active');
          }
        } else {
          direction = -1;

          tl.reverse();
          if (!html.classList.contains('active')) {
            html.classList.add('active');
          }
        }
        tween.prevDirection = tween.direction;
      }
    }

    mainTL = gsap.timeline({
      scrollTrigger: {
        trigger: wrapper,
        start: 'top+=100 center',
        end: 'bottom-=100 center',
        //  markers:true,
        scrub: false,
        pin: true,
        invalidateOnRefresh: true, //resizeで更新、早くスクロールした場合も対応
        anticipatePin: 1,
        toggleActions: 'play pause resume reverse',
        onEnter: mainTLonEnter,
        onEnterBack: mainTLonEnterBack,
        onUpdate: mainTLonUpdate,
        onUpdateParams: ["{tween}"]
      }
    });


    /*--------------------------------------
    各イメージタイムライン
    */

    let elements = gsap.utils.toArray(".rnd");


    function calcDistance(elm, index) {
      let val;
      if (index < 25) {
        val = Math.round((elm.clientHeight / 2) + (wh * 2) + (elements.length - index));
      } else {
        val = wh * 2.1;
      }
      return "-=" + val + 'px';
    }


    elements.forEach((elm, index) => {

      let distance = calcDistance(elm, index);

      //移動アニメーション
      let elmTL = gsap.timeline({
        onComplete: () => {
          if ((index + 1) === elements.length) {
            //if(tl.isActive()){
            html.classList.add('end');
            //}
            html.classList.remove('active');
          }
        },
        onReverseComplete: () => {
          if (index === 0) {

            html.classList.remove('end');
            html.classList.remove('active');

          }
        }
      }).to(elm, {
        y: () => distance,
        duration: 2
      });

      let elmOpacityTL;

      if (elm.classList.contains('rnd-H')) {
        //すぐに隠す画像
        elmOpacityTL = gsap.timeline({
          scrollTrigger: {
            trigger: elm,
            scrub: false,
            once: true
          }
        }).set(elm, {
          autoAlpha: 0
        }).to(elm, {
          autoAlpha: 1,
          duration: 0.5
        }).to(elm, {
          autoAlpha: 1,
          duration: 0.5
        }).to(elm, {
          autoAlpha: 0
        });
      }

      if (elm.classList.contains('rnd-O')) {
        //すぐに隠さず、出しっぱなしでもない要素
        elmOpacityTL = gsap.timeline({
          scrollTrigger: {
            start: 'top bottom',
            scrub: false,
            toggleActions: 'play pause resume reverse',
          }
        }).set(elm, {
          autoAlpha: 0
        }).to(elm, {
          autoAlpha: 0,
          duration: 0.2,
          delay: () => (index / 30),
        }).to(elm, {
          autoAlpha: 1,
          duration: () => 0.6
        })
      }

      tl.add(elmTL, 0);
      if (elmOpacityTL) { tl.add(elmOpacityTL, 0); }

    });

    /*--------------------------------------
    イメージセクション下の要素を監視
    */

    const endElement = document.querySelector('.countup__after');

    let observerTL = gsap.timeline({
      scrollTrigger: {
        trigger: endElement,
        start: 'top center',
        onEnter: () => {
          // console.log('end element on screen');
          if (direction > 0) {
            html.classList.remove('active');
            html.classList.add('end');
          }
        }
      }
    })

    gsapInit = true;

  }


  /*--------------------------------------
  hashの有無
  */

  let hashTimer = 0;

  window.addEventListener("load", (e) => {
    html.style.scrollBehavior = "auto";
    if (!hash) {
      runGsap();
    } else {

      if (hashTimer) clearTimeout(hashTimer);

      hashTimer = setTimeout(() => {
        const target = document.querySelector('.page__title-block');
        const callback = function (entries, observer) {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('in');
              if (!gsapInit) {
                html.style.scrollBehavior = "auto";
                runGsap();
                io.disconnect();
              }
            }
          });
        };
        const io = new IntersectionObserver(callback, { threshold: 1 });
        io.observe(target);
        setTimeout(function () {
          clearTimeout(hashTimer);
        }, 1500);
      }, 500);

    }
  }, { passive: true });
});
